import auth from '@/auth/authService';
import store from '../store/index';

// Google Tag Manager
(function(w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l != 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-558ZHFB');
// End Google Tag Manager

if (auth.isAuthenticated()) {
  const tokenData = auth.getToken().split('.');
  const data = JSON.parse(atob(tokenData[1]));

  if (data && data.client_id) {
    window.global_harness_user = {
      firstname: data['fname'],
      lastname: data['lname'],
      email: data['client_email'],
      id: data['client_id'],
      active_charity_id: store.state.auth.activeCharityId,
    };
  }
}
